import clsx from 'clsx';
import { Mark, MarkLabel } from './styles/range-control-styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function RangeMark(props) {
  const {
    className,
    isFilled = false,
    label,
    style = {},
    ...otherProps
  } = props;
  const classes = clsx('components-range-control__mark', isFilled && 'is-filled', className);
  const labelClasses = clsx('components-range-control__mark-label', isFilled && 'is-filled');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Mark, {
      ...otherProps,
      "aria-hidden": "true",
      className: classes,
      style: style
    }), label && /*#__PURE__*/_jsx(MarkLabel, {
      "aria-hidden": "true",
      className: labelClasses,
      isFilled: isFilled,
      style: style,
      children: label
    })]
  });
}